<template>
  <edit-employee-layout screen="project" :employee-id="empNumber">
    <div class="gsl-hrm-horizontal-padding gsl-hrm-vertical-padding">
      <oxd-text tag="h6" class="gsl-hrm-main-title">{{
        $t('general.projects')
      }}</oxd-text>
    </div>
  </edit-employee-layout>
</template>
<script>
import EditEmployeeLayout from '@/orangehrmPimPlugin/components/EditEmployeeLayout';

export default {
  components: {
    'edit-employee-layout': EditEmployeeLayout,
  },
  props: {
    empNumber: {
      type: String,
      required: true,
    },
  },
};
</script>
